import { render, staticRenderFns } from "./ComputerVerified.vue?vue&type=template&id=52993cbe&"
import script from "./ComputerVerified.vue?vue&type=script&lang=js&"
export * from "./ComputerVerified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports